import React, { useState, useEffect, useRef } from 'react';
import PopupBtmModifyCarInfo from './components/chatbot/PopupBtmModifyCarInfo';
import ChatbotHeader from './components/chatbot/ChatbotHeader';
import MessageConsultant from './components/chatbot/MessageConsultant';
import MessageConsultantFirst from './components/chatbot/MessageConsultantFirst';
import MessageUser from './components/chatbot/MessageUser';
import MessageConsultantSecond from './components/chatbot/MessageConsultantSecond';
import PopupBtmSelectArea from './components/chatbot/PopupBtmSelectArea';
import PopupBtmPartRepair from './components/chatbot/PopupBtmPartRepair';
import PopupBtmBookDate from './components/chatbot/PopupBtmBookDate';
import { formatReservationDate } from '../util/formatReservationDate';
import PopupBtmModifyPhoneNumber from './components/chatbot/PopupBtmModifyPhoneNumber';
import PopupBtmAddRequest from './components/chatbot/PopupBtmAddRequest';
import PopupBtmResult from './components/chatbot/PopupBtmResult';
import PopupBtmAgree from './components/chatbot/PopupBtmAgree';
import PopupConfirmLoader from './components/chatbot/PopupConfirmLoader';
// import { useLocation } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import { carInfoState } from '../recoil/atom';

const Chatbot = () => {
  /* const location = useLocation();
  const receivedCarInfo = location.state?.carInfo;
  const [carInfo, setcarInfo] = useState(receivedCarInfo); */

  const [carInfo, setcarInfo] = useRecoilState(carInfoState);


  // 팝업 상태
  const [isShowModifyCarInfo, setisShowModifyCarInfo] = useState(false);
  const [isShowSelectArea, setisShowSelectArea] = useState(false);
  const [isShowPartRepair, setisShowPartRepair] = useState(false);
  const [isShowBookDate, setisShowBookDate] = useState(false);
  const [isShowPhoneNumber, setisShowPhoneNumber] = useState(false);
  const [isShowAddRequest, setisShowAddRequest] = useState(false);
  const [isShowResult, setisShowResult] = useState(false);
  const [isShowAgree, setisShowAgree] = useState(false);

  // 진행 상태
  const [isCompleteCarinfo, setisCompleteCarinfo] = useState(false);
  const [isCompleteSelectArea, setisCompleteSelectArea] = useState(false);
  const [isCompletePartRepair, setisCompletePartRepair] = useState(false);
  const [isCompleteBookDate, setisCompleteBookDate] = useState(false);
  const [isCompletePhoneNumber, setisCompletePhoneNumber] = useState(false);
  const [isCompleteAddRequest, setisCompleteAddRequest] = useState(false);
  const [isCompleteAddRequestNone, setisCompleteAddRequestNone] = useState(false);
  const [isCompleteResult, setisCompleteResult] = useState(false);
  const [isCompleteAgree, setisCompleteAgree] = useState(false);



  // 메시지 표시 상태 애니메이션
  const [messageStates, setMessageStates] = useState({
    carInfo: { user: false, first: false, second: false },
    area: { user: false, first: false, second: false },
    part: { user: false, first: false, second: false },
    date: { user: false, first: false, additional: false },
    phone: { user: false, first: false, second: false },
    AddRequest: { user: false, first1: false, first2: false, second: false }, // Make sure second is included
    agree: { user: false, first: false, second: false },
  });


  // 스크롤 함수
  const chatContentRef = useRef();
  const scrollTimeoutRef = useRef(null);
  const retryCountRef = useRef(0);
  const MAX_RETRIES = 3;

  const scrollToBottom = () => {
    // Clear any existing timeout
    if (scrollTimeoutRef.current) {
      clearTimeout(scrollTimeoutRef.current);
    }

    const performScroll = () => {
      if (!chatContentRef.current) return;
      
      const scrollHeight = chatContentRef.current.parentElement?.scrollHeight || 0;
      const currentScroll = chatContentRef.current.parentElement?.scrollTop || 0;
      const clientHeight = chatContentRef.current.parentElement?.clientHeight || 0;
      
      // Check if we're already at bottom
      if (scrollHeight - currentScroll <= clientHeight + 10) {
        retryCountRef.current = 0;
        return;
      }

      chatContentRef.current.parentElement?.scrollTo({
        top: scrollHeight,
        behavior: 'smooth'
      });

      // Verify scroll position after animation
      scrollTimeoutRef.current = setTimeout(() => {
        if (chatContentRef.current && retryCountRef.current < MAX_RETRIES) {
          const newScrollHeight = chatContentRef.current.parentElement?.scrollHeight || 0;
          const newCurrentScroll = chatContentRef.current.parentElement?.scrollTop || 0;
          const newClientHeight = chatContentRef.current.parentElement?.clientHeight || 0;

          // If not scrolled to bottom, retry
          if (newScrollHeight - newCurrentScroll > newClientHeight + 10) {
            retryCountRef.current++;
            performScroll();
          } else {
            retryCountRef.current = 0;
          }
        }
      }, 150);
    };

    // Initial delay to allow DOM updates
    setTimeout(performScroll, 100);
  };

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }
    };
  }, []);

  // 메시지 표시 함수
  const showMessagesSequentially = (section, order = ['user', 'first', 'second']) => {
    order.forEach((type, index) => {
      setTimeout(() => {
        setMessageStates(prev => ({
          ...prev,
          [section]: { ...prev[section], [type]: true }
        }));
        scrollToBottom();
      }, index * 500);
    });
  };

  // 각 완료 상태에 대한 useEffect
  useEffect(() => {
    if (isCompleteCarinfo) showMessagesSequentially('carInfo');
  }, [isCompleteCarinfo]);

  useEffect(() => {
    if (isCompleteSelectArea) showMessagesSequentially('area');
  }, [isCompleteSelectArea]);

  useEffect(() => {
    if (isCompletePartRepair) showMessagesSequentially('part');
  }, [isCompletePartRepair]);

  useEffect(() => {
    if (isCompleteBookDate) {
      showMessagesSequentially('date', ['user', 'first', 'additional']);
    }
  }, [isCompleteBookDate]);

  useEffect(() => {
    if (isCompletePhoneNumber) showMessagesSequentially('phone');
  }, [isCompletePhoneNumber]);


  useEffect(() => {
    if (isCompleteAddRequest || isCompleteAddRequestNone) {
      showMessagesSequentially('AddRequest', ['user', 'first1', 'first2', 'second']);
    }
  }, [isCompleteAddRequest, isCompleteAddRequestNone]);

  useEffect(() => {
    if (isCompleteAgree) showMessagesSequentially('agree');
  }, [isCompleteAgree]);



  // isCompleteAgree가 변경될 때 타이머 시작
  const [showLoader, setShowLoader] = useState(false);
  useEffect(() => {
    if (isCompleteAgree) {
      // 2초 후에 로더 표시
      const timer = setTimeout(() => {
        setShowLoader(true);
      }, 2000);

      // 컴포넌트 언마운트 시 타이머 정리
      return () => clearTimeout(timer);
    }
  }, [isCompleteAgree]);



  return (
    <>
      {/* 차량정보 수정하기 */}
      {isShowModifyCarInfo &&
      <PopupBtmModifyCarInfo
        setisShowModifyCarInfo={setisShowModifyCarInfo}
        setisCompleteCarinfo={setisCompleteCarinfo}
        carInfo={carInfo}
        setcarInfo={setcarInfo}
      />}
      {/* 지역 선택하기 */}
      {isShowSelectArea &&
      <PopupBtmSelectArea
        setisShowSelectArea={setisShowSelectArea}
        setisCompleteSelectArea={setisCompleteSelectArea}
        carInfo={carInfo}
        setcarInfo={setcarInfo}
      />}
      {/* 사고부위 선택하기 */}
      {isShowPartRepair &&
      <PopupBtmPartRepair
        setisShowPartRepair={setisShowPartRepair}
        setisCompletePartRepair={setisCompletePartRepair}
        carInfo={carInfo}
        setcarInfo={setcarInfo}
      />}
      {/* 예약날짜 선택하기 */}
      {isShowBookDate &&
      <PopupBtmBookDate
        setisShowBookDate={setisShowBookDate}
        setisCompleteBookDate={setisCompleteBookDate}
        carInfo={carInfo}
        setcarInfo={setcarInfo}
      />}
      {/* 연락처 입력하기 */}
      {isShowPhoneNumber &&
      <PopupBtmModifyPhoneNumber
        setisShowPhoneNumber={setisShowPhoneNumber}
        setisCompletePhoneNumber={setisCompletePhoneNumber}
        carInfo={carInfo}
        setcarInfo={setcarInfo}
      />}
      {/* 추가문의사항 */}
      {isShowAddRequest &&
      <PopupBtmAddRequest
        setisShowAddRequest={setisShowAddRequest}
        setisCompleteAddRequest={setisCompleteAddRequest}
        carInfo={carInfo}
        setcarInfo={setcarInfo}
      />}
      {/* 최종접수정보 */}
      {isShowResult &&
      <PopupBtmResult
        setisShowResult={setisShowResult}
        setisCompleteResult={setisCompleteResult}
        carInfo={carInfo}
        setcarInfo={setcarInfo}
        setisShowSelectArea={setisShowSelectArea}
        setisCompleteSelectArea={setisCompleteSelectArea}
        setisShowBookDate={setisShowBookDate}
        setisCompleteBookDate={setisCompleteBookDate}
        setisShowPartRepair={setisShowPartRepair}
        setisCompletePartRepair={setisCompletePartRepair}
        setisShowAgree={setisShowAgree}
      />}
      {/* 약관동의 */}
      {isShowAgree && (
        <PopupBtmAgree
          setisShowAgree={setisShowAgree}
          setisCompleteAgree={setisCompleteAgree}
        />
      )}

      <div className="flex flex-col h-screen bg-gray-50">
        <ChatbotHeader carNumber={carInfo.carNumber} />

        <div className="relative flex-1 p-5 overflow-y-auto">
          <MessageConsultant>
            <MessageConsultantFirst text={`고객님, 차량 수리 예약을 도와드릴게요!\n아래 입력하신 차량 정보가 맞으신가요?`} />
            <MessageConsultantSecond
              text={`차량번호 : ${carInfo.carNumber}\n차량명 : ${carInfo.carName}\n연식 : ${carInfo.carYear}`}
              btn1={`수리 예약 시작하기`}
              btn2={`차량 정보 수정하기`}
              btn1OnClick={setisCompleteCarinfo}
              btn2OnClick={setisShowModifyCarInfo}
              isComplete={isCompleteCarinfo}
            />
          </MessageConsultant>

          {isCompleteCarinfo && (
            <>
              {messageStates.carInfo.user && (
                <MessageUser clickModify={setisShowModifyCarInfo}>
                  <p className='text-[15px]'>네, 제 차가 맞아요!</p>
                </MessageUser>
              )}
              {messageStates.carInfo.first && (
                <MessageConsultant>
                  <MessageConsultantFirst text={`네, 고객님 차량으로 확인했습니다!`} />
                  {messageStates.carInfo.second && (
                    <MessageConsultantSecond
                      text={`고객님께서 수리맡기기 편한 지역을\n 선택해주세요.`}
                      btn1={`지역 선택하기`}
                      btn1OnClick={setisShowSelectArea}
                      isComplete={isCompleteSelectArea}
                    />
                  )}
                </MessageConsultant>
              )}
            </>
          )}

          {isCompleteSelectArea && (
            <>
              {messageStates.area.user && (
                <MessageUser clickModify={setisShowSelectArea}>
                  <p className='text-[15px]'><b>{carInfo.carRegion}</b>에서 수리 받고 싶어요.</p>
                </MessageUser>
              )}
              {messageStates.area.first && (
                <MessageConsultant>
                  <MessageConsultantFirst text={`네, <b>${carInfo.carRegion}</b>에 있는 업체를 찾아드리겠습니다!`} />
                  {messageStates.area.second && (
                    <MessageConsultantSecond
                      text={`수리하실 차량 사고 부위를 알려주세요.`}
                      btn1={`사고 부위 선택하기`}
                      btn1OnClick={setisShowPartRepair}
                      isComplete={isCompletePartRepair}
                    />
                  )}
                </MessageConsultant>
              )}
            </>
          )}

          {isCompletePartRepair && (
            <>
              {messageStates.part.user && (
                <MessageUser clickModify={setisShowPartRepair}>
                  <p className='text-[15px]'>{carInfo.carRepairPart.length}군데 수리가 필요해요.</p>
                  <ul className='text-[15px] mt-1 list-disc pl-4'>
                    {carInfo.carRepairPart.map((part, index) => (
                      <li key={index}><b>{part}</b></li>
                    ))}
                  </ul>
                </MessageUser>
              )}
              {messageStates.part.first && (
                <MessageConsultant>
                  <MessageConsultantFirst text={`네, 사고 ${carInfo.carRepairPart.length}부위를 확인했습니다!`} />
                  {messageStates.part.second && (
                    <MessageConsultantSecond
                      text={`원하시는 <b>희망 예약일</b>을 선택해주세요.`}
                      btn1={`예약 날짜 선택하기`}
                      btn1OnClick={setisShowBookDate}
                      isComplete={isCompleteBookDate}
                    />
                  )}
                </MessageConsultant>
              )}
            </>
          )}

          {isCompleteBookDate && (
            <>
              {messageStates.date.user && (
                <MessageUser clickModify={setisShowBookDate}>
                  <p className='text-[15px]'>
                    <b className='keep-all'>
                      {formatReservationDate(carInfo.carReservationDate[0])},
                      {formatReservationDate(carInfo.carReservationDate[1])}
                    </b>으로 예약할게요.
                  </p>
                </MessageUser>
              )}
              {messageStates.date.first && (
                <MessageConsultant>
                  <MessageConsultantFirst text="네 희망 예약 날짜를 확인했습니다!" />
                  {messageStates.date.additional && (
                    <MessageConsultantSecond 
                      text="안내 받으실 연락처를 알려주세요!"
                      btn1="연락처 입력하기"
                      btn1OnClick={setisShowPhoneNumber}
                      isComplete={isCompletePhoneNumber}
                    />
                  )}
                </MessageConsultant>
              )}
            </>
          )}


          {isCompletePhoneNumber && (
            <>
              {messageStates.phone.user && (
                <MessageUser clickModify={setisShowPhoneNumber} isNotModify={true}>
                  <p className='text-[15px]'><b>{carInfo.userPhoneNumber}</b>입니다.</p>
                </MessageUser>
              )}
              {messageStates.phone.first && (
                <MessageConsultant>
                  <MessageConsultantFirst text="네, 알려주신 연락처로 안내해 드리겠습니다!" />
                  {messageStates.phone.second && (
                    <MessageConsultantSecond
                      text="고객님, 추가로 남기고 싶으신 요청사항이 있으실까요?"
                      btn1="요청사항 입력하기"
                      btn2="요청사항 없음"
                      btn1OnClick={setisShowAddRequest}
                      btn2OnClick={setisCompleteAddRequestNone}
                      isComplete={isCompleteAddRequest || isCompleteAddRequestNone}
                    />
                  )}
                </MessageConsultant>
              )}
            </>
          )}

          {(isCompleteAddRequest || isCompleteAddRequestNone) && (
            <>
              {messageStates.AddRequest.user && (
                <MessageUser clickModify={setisShowAddRequest}>
                  {carInfo.userRequest
                    ? <p className='text-[15px]'>{carInfo.userRequest}</p>
                    : <p className='text-[15px]'>없습니다.</p>
                  }
                </MessageUser>
              )}
              {messageStates.AddRequest.first1 && (
                <MessageConsultant>
                  <MessageConsultantFirst text="네, 확인했습니다!" />
                  {messageStates.AddRequest.first2 && (
                    <MessageConsultantFirst text="고객님, 마지막으로 입력하신 정보들이 맞는지 확인해주세요." />
                  )}
                  {messageStates.AddRequest.second && (
                    <MessageConsultantSecond
                      text={`<b>이름 : ${carInfo.userName} 고객님
                          차량번호 : ${carInfo.carNumber}
                          지역 : ${carInfo.carRegion}
                          희망 예약일 :
                          · ${formatReservationDate(carInfo.carReservationDate[0])}
                          · ${formatReservationDate(carInfo.carReservationDate[1])}
                          수리부위 : ${carInfo.carRepairPart}
                          요청사항 : ${carInfo.userRequest || '없음'}</b>
                      `}
                      btn1="접수하기"
                      btn2="수정하기"
                      btn1OnClick={setisShowAgree}
                      btn2OnClick={setisShowResult}
                      isComplete={isCompleteAgree}
                    />
                  )}
                </MessageConsultant>
              )}
            </>
          )}


          {isCompleteAgree && (
            <>
              {messageStates.agree.user && (
                <MessageUser clickModify={setisShowAddRequest}>
                  <p className='text-[15px]'>
                    네, 접수할게요!
                  </p>
                </MessageUser>
              )}
              {messageStates.agree.first && (
                <MessageConsultant>
                  <MessageConsultantFirst text={`접수가 완료되었습니다!\n고객님께 딱 맞는 수리업체를\n바로 확인해드리겠습니다.`} />
                </MessageConsultant>
              )}
              {/* 로더 조건부 렌더링 */}
              {showLoader && <PopupConfirmLoader />}
            </>
          )}
          <div ref={chatContentRef} className="h-[1px]" />
        </div>
      </div>
    </>
  );
};

export default Chatbot;